export default {
    configuration: true,
    'table': {
        'switchType': true,
        'tableCut': false,
        'clickState': false,
        'selectBtn': true,
        'height': 'calc(100vh - 225px)',
        'statesY': '启用',
        'statesN': '停用',
        'columns': [
            {
                'label': '仓库编号',
                'prop': 'businessCode',
                'width': '150px'
            },
            {
                'label': '审批类型',
                'prop': 'auditType_',
                'width': '200px'
            },
            {
                'label': '审批状态',
                'prop': 'auditStatus_',
                'width': '200px'
            },
            {
                'label': 'MIP审批流编码',
                'prop': 'auditMipId',
                'width': '200px'
            },
            {
                'label': '创建人',
                'prop': 'createUserName',
                'width': '200px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '200px'
            }
        ],
        'action':
            [
                {
                    'type': 'text',
                    'label': '查看流程',
                    'size': 'mini',
                    'event': 'attachment'
                },
                {
                    'type': 'text',
                    'label': '删除',
                    'size': 'mini',
                    'event': 'del'
                }
            ],
        'leftOperation': true,
        'leftWidth': 130
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};